import { WebApi } from '@/services/WebApi'

const state = () => ({
  loadingVetContact: false,
  loadedVetContact: false,
  vetContactCache: null
})

const mutations = {
  setVetContact (state, vetContact) {
    state.vetContactCache = vetContact
    state.loadedVetContact = true
  },
  setLoading (state, value) {
    state.loadingVetContact = !!value
  }
}

const actions = {
  fetchVetContact ({ commit }, inviteId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.get('ClientOnboardingInvite/' + inviteId + '/Vet/Contact')
        .then(response => {
          commit('setVetContact', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  },
  addVetContact ({ commit }, { inviteId, payload }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.post('ClientOnboardingInvite/' + inviteId + '/Vet/Contact', payload)
        .then(response => {
          commit('setVetContact', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  },
  updateVetContact ({ commit }, { inviteId, payload }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.put('ClientOnboardingInvite/' + inviteId + '/Vet/Contact', payload)
        .then(response => {
          commit('setVetContact', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
